import PropTypes from 'prop-types';

const pageUtilsPropTypes = PropTypes.shape({
  loadSomething: PropTypes.func.isRequired,
  loadSomethingSilent: PropTypes.func.isRequired,
  loadSomethingSilentRaw: PropTypes.func.isRequired,
  showSnackbar: PropTypes.func.isRequired,
});

export default pageUtilsPropTypes;
